import axios from "axios";
import { showGlobalToast } from "@/context/ToastContext";


const api = axios.create({
    // baseURL: "http://127.0.0.1:8000/api/",
    baseURL: "https://api-nimba-afromarket.waitech.tech/api/",
    timeout: 15000, //15s
    headers: {
        "Content-Type" : "application/json",
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

const AUTH_EXEMPT_401_ROUTES = ["vendeur/password"];

const NO_RESPONSE_TOAST_DURATION = 5000;
// Si plusieurs requetes echouent en meme temps (page qui charge 5 hooks en parallele,
// backend injoignable), on ne veut qu'un seul toast a l'ecran, pas cinq empiles.
let noResponseToastActive = false;

api.interceptors.response.use(
  res => res,
  err => {
    const url: string = err.config?.url || "";
    const isExempt = AUTH_EXEMPT_401_ROUTES.some((route) => url.includes(route));

    if (err.response?.status === 401 && !isExempt) {
      localStorage.removeItem("token");
      localStorage.removeItem("nimba_auth_user");
      if (window.location.pathname !== "/connexion") {
        window.location.href = "/connexion";
      }
    }

    // Aucune reponse recue (timeout 15s ou serveur injoignable) — le hook appelant
    // affichera en plus son propre message d'erreur le cas echeant, mais celui-ci
    // garantit qu'on ne laisse jamais l'app charger indefiniment sans retour visuel.
    if (!err.response && !noResponseToastActive) {
      noResponseToastActive = true;
      setTimeout(() => { noResponseToastActive = false; }, NO_RESPONSE_TOAST_DURATION);

      showGlobalToast({
        type: 'error',
        message: err.code === 'ECONNABORTED'
          ? "Le serveur met trop de temps a repondre. Veuillez reessayer."
          : "Impossible de contacter le serveur. Verifiez votre connexion.",
        duration: NO_RESPONSE_TOAST_DURATION,
      });
    }

    return Promise.reject(err);
  }
);

export default api;